export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// export const phoneRegex = /^[0-9]{10}$/;
export const phoneRegex = /^(0|\+33)[1-9]\d{8}$/;
export const yearsOfExperienceRegex = /^-?\d+(\.\d+)?$/;
export const linkedInRegex =
  /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]{5,30}\/?$/;
